import { useCallback, useState } from 'react';
import { IRelatedAccountInfo } from '../interface/relatedAccount';
import { switchAccount } from '../dataServices/authDataService';
import { getLangText } from '../services/langService';
import { AlertDialog } from '../common/components/modalDialog';
import { gotoAuthPanel } from '../utils/util';
import { isMobile } from '@umu/umu-ua';
/**
 * 切换账号
 */
interface IErrorMsg {
    title: string;
    content: string;
    showClose?: boolean;
    className?: string;
    btnConfirmText?: string;
}
/**
 * @desc 错误展示集合 key: 错误码  value: 错误展示信息弹窗内容 IErrorMsg
*/
const errorCodeMsgMap: Record<string, IErrorMsg> = {
    20007: {
        title: getLangText('账户被禁用'),
        content: '',
        showClose: false,
    }
};
const showDialog = (errMsg: IErrorMsg)=>{
    if (!isMobile) {
        AlertDialog({
            showClose: true,
            className: 'switch-account-alert-dialog-pc',
            btnConfirmText: getLangText('知道了'),
            ...errMsg,
        });
    } else {
        AlertDialog({
            className: 'switch-account-alert-dialog',
            btnConfirmText: getLangText('确认'),
            ...errMsg,
        });
    }
}

export default function useSwitchAccount(lang: string) {
    const [isSwitching, setSwitching] = useState(false);

    const onSwitchAccount = useCallback(
        (account: IRelatedAccountInfo) => {
            if (!account) {
                return;
            }
            setSwitching(true);
            switchAccount(account.user_token).then(function (ret) {
                if (ret.data) {
                    if (ret.data.code && ret.data.code === 50044) {
                        //50044 : 开启了两步认证跳转两步认证页面
                        gotoAuthPanel('/authenticator/mfa/index', {
                            from_url: encodeURIComponent(window.location.href),
                            sessionCode: ret.data.otp.session_code,
                            type: 'switchAccount',
                        });
                        return;
                    }
                    if (ret.data.success_code != 1) {
                        showDialog({
                            title: !isMobile ? getLangText('重新登录') : getLangText('提示'),
                            content: getLangText(
                                '该账户已修改密码，为保护账户安全，请先退出当前账户后重新登录。',
                            )
                        });
                        setSwitching(false);
                        return;
                    }
                    window.location.href = '/';
                    return;
                } else {
                    // 后端错误信息
                    const errMsg = ret.error || ret.errMsg || ret.error_message;
                    const errorCode = ret.error_code;
                    const errorCodeMsg = errorCodeMsgMap[errorCode];
                    errMsg && showDialog({
                        title: getLangText('提示'),
                        ...errorCodeMsg,
                        content: errorCodeMsg && errorCodeMsg.content || errMsg,
                    });
                }
                setSwitching(false);
            });
        },
        [lang],
    );

    return { isSwitching, onSwitchAccount };
}
